import { render, staticRenderFns } from "./P023.vue?vue&type=template&id=5fdd5e11"
import script from "./P023.vue?vue&type=script&lang=js"
export * from "./P023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports